import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/images";

export const PackageSection = ({ pkg, onReserve }) => (
  <section id="package" data-testid="package-section" className="py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-12 lg:grid-cols-2 lg:px-20">
      <Reveal className="relative">
        <div className="absolute -inset-3 rounded-3xl border border-gold/25" aria-hidden="true" />
        <div className="spotlight-card group relative aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5]">
          <img
            src={IMAGES.cityNight}
            alt="Atlanta skyline at night"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent" />
          <p className="absolute bottom-6 left-6 font-mono text-[11px] tracking-[0.3em] text-gold uppercase">
            ATL Runway → Valet Stand
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="eyebrow">Signature Package</p>
        <h2 className="mt-4 font-serif text-3xl font-semibold text-slate-100 sm:text-4xl lg:text-5xl">
          Touchdown <span className="gold-gradient-text italic">Royal</span>
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-zinc-400">
          One request. Everything handled. We meet you at the aircraft, hand you
          the keys to the Escalade V, and have the penthouse lit, chilled, and
          stocked before you reach the 45th floor.
        </p>
        <ul className="mt-8 space-y-4">
          {(pkg?.includes ?? []).map((inc) => (
            <li key={inc} className="flex items-start gap-3 text-sm text-zinc-300">
              <span className="mt-0.5 rounded-full border border-gold/30 p-1 text-gold">
                <Check size={12} />
              </span>
              {inc}
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-wrap items-center gap-6">
          <p className="font-serif text-4xl text-slate-100">
            ${(pkg?.flat_rate ?? 2499).toLocaleString()}
            <span className="ml-2 font-sans text-sm text-zinc-500">/ 3 nights, all-in</span>
          </p>
          <button
            data-testid="package-reserve-btn"
            onClick={() => onReserve("package", pkg?.id ?? "touchdown-royal")}
            className="rounded-full bg-gold px-8 py-4 font-display text-xs font-semibold tracking-[0.25em] text-obsidian uppercase transition-all hover:bg-gold-bright hover:shadow-[0_0_40px_rgba(212,175,55,0.35)]"
          >
            Claim the Package
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
